import { useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { authApi } from '../services/api'

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const navigate = useNavigate()
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [message, setMessage] = useState({ type: '', text: '' })

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!newPassword || newPassword.length < 6) {
      setMessage({ type: 'error', text: 'La contraseña debe tener al menos 6 caracteres' })
      return
    }
    if (newPassword !== confirmPassword) {
      setMessage({ type: 'error', text: 'Las contraseñas no coinciden' })
      return
    }
    setSubmitting(true)
    setMessage({ type: '', text: '' })
    try {
      await authApi.resetPassword(token, newPassword)
      setMessage({ type: 'success', text: 'Contraseña actualizada. Ya puedes iniciar sesión.' })
      setTimeout(() => navigate('/login/admin'), 2000)
    } catch (err: any) {
      setMessage({ type: 'error', text: err.response?.data?.error || 'El enlace es inválido o expiró' })
    } finally {
      setSubmitting(false)
    }
  }

  if (!token) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-cream-100">
        <div className="max-w-md w-full space-y-4 p-8 bg-cream-50 rounded-lg shadow-md text-center">
          <p className="text-red-600">Enlace inválido o incompleto.</p>
          <Link to="/login/admin" className="text-sm text-terracotta-700 hover:text-terracotta-800">
            Volver al inicio de sesión
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-cream-100">
      <div className="max-w-md w-full space-y-6 p-8 bg-cream-50 rounded-lg shadow-md">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-terracotta-700">☕ Cafe Distribution</h1>
          <p className="mt-2 text-espresso-600">Restablecer Contraseña</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="newPassword" className="block text-sm font-medium text-espresso-700 mb-1">
              Nueva Contraseña
            </label>
            <input
              id="newPassword"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-3 py-2 border border-espresso-200 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500 focus:border-terracotta-500"
              autoFocus
            />
            <p className="text-xs text-espresso-500 mt-1">Mínimo 6 caracteres</p>
          </div>
          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-espresso-700 mb-1">
              Confirmar Nueva Contraseña
            </label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-3 py-2 border border-espresso-200 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500 focus:border-terracotta-500"
            />
          </div>
          {message.type && (
            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-700'}`}>
              {message.text}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-terracotta-600 hover:bg-terracotta-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta-500 disabled:opacity-50"
          >
            {submitting ? 'Guardando...' : 'Restablecer Contraseña'}
          </button>
        </form>
      </div>
    </div>
  )
}
